import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Flex,
  TreeSelect,
  notification,
  Typography,
  Dropdown,
} from "antd";
import {
  ExpandOutlined,
  ShrinkOutlined,
  DownOutlined,
  ExportOutlined
} from "@ant-design/icons";
import dayjs from 'dayjs';
import { v4 as uuidv4 } from "uuid";

// ** Components ( Start )
import common_api from "../../config/common_api";
import { useAuth } from "../UserAuth/AuthContext";
import CommonAttributeList from "../common/CommonAttributeList";
import StatusBadge from "../common/StatusBadge";
import UploadButton from "../common/UploadButton";
import { triggerNotification } from "../common/notify";
import MultiKitProductGroupList from "./MultiKitProductGroupList";
import globalData from "../../config/global_data";
import customParseFormat from 'dayjs/plugin/customParseFormat';
// ** Components ( End )

// ** Plugins ( Start )
dayjs.extend(customParseFormat);
const { Text } = Typography;
// ** Plugins ( End )


const MultiKitDrawer = ({ visible, onClose, kidata, setisloader, onProductCreate }) => {

  // ** States ( Start )
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState(null)
  const [bundleTitle, setBundleTitle] = useState("New Kit Product");
  const [imageObj, setImageObj] = useState(null);
  const [thumbnailObj, setThumbnailObj] = useState(null);
  const [data, setData] = useState(kidata);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [savedimages, setSavedimgaes] = useState(null);
  const [savedattributes, setSavedattributes] = useState(null);
  const [removedValues, setRemovedValues] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [innerProducts, setInnerProducts] = useState(null);
  const [hasAttributeError, setHasAttributeError] = useState(false);
  // ** States ( End )

  // ** Hooks ( Start )
  const { userData } = useAuth();
  // ** Hooks ( End )




  // ** Functions ( Start )
  const ButtonItems = [
    {
      label: 'Save & Draft',
      key: 'saveDraft',
      disabled: true,
    },
    {
      label: 'Save & Reload',
      key: 'saveReload',
      disabled: true,
    },
  ];

  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };


  const onChange = (values) => {
    setSelectedValues(values);
  };




  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete!',
      message: "Please fix all errors before saving.",
    });
  };
  const handleInputChange = (name) => (e) => {
    let value = e.target.value;
    // Remove all non-numeric characters (including dot)
    value = value.replace(/[^0-9]/g, '');
    // Set the cleaned value in the form
    form.setFieldsValue({ [name]: value });
  };
  const handleBlur = () => {
    const bundleName = form.getFieldValue("KitName");
    if (bundleName === "") {
      setBundleTitle(kidata.kitname);
    }
    else if (bundleName) {
      setBundleTitle(bundleName);
    }
  };
  const handleSaveAndPublishClick = () => {


    // Validate SKU selection for all products
    if (hasAttributeError) {
      triggerNotification({
        type: 'error',
        title: 'Attribute Error!',
        message: 'Please fix all errors before saving.'
      });
      return;
    }
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };

  const handleSaveAndPublish = async (values) => {

    // return 1;

    let images = []
    let available_images = kidata.images
    let custom_fields_final = [], custom_fields_removed = [], currentImageUrls = [];
    let remove_from_GCP = []
    if (savedimages?.image_data?.length > 0) {
      images = await savedimages.image_data.map(item => {
        if (item.thumbUrl && item.thumbUrl.startsWith('https://storage.googleapis.com/')) {
          remove_from_GCP.push(item.thumbUrl)
        }
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl,
            is_thumbnail: item.set_as_Featured,
            sort_order: item.img_order
          }
        } else {
          return {
            url_standard: item.thumbUrl,
            image_url: item.thumbUrl

          }
        }

      })
    }
    if (savedattributes?.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      data.forEach(attr => {
        const { values, attribute_key, max_size } = attr;

        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item.val) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "id": item.key,
                "name": baseKey.replace("NUM", counter),
                "value": item.val
              }
            } else if (max_size === 1) {
              itemobj = {
                "id": item.key,
                "name": baseKey,
                "value": item.val
              }
            }
            else {
              itemobj = {
                "id": item.key,
                "name": baseKey + "_" + counter,
                "value": item.val
              }
            }
            if (itemobj.id === "") {
              delete itemobj.id
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });

    }
    if (removedValues && removedValues.custom_fields && removedValues.custom_fields.length > 0) {
      custom_fields_removed = removedValues.custom_fields
    }

    if (values.DiscountValue) {
      let disobj = {
        "name": "DISCOUNT_%",
        "value": values.DiscountValue.toString()
      }
      if (data?.discount?.id) {
        disobj.id = data.discount.id
      }
      custom_fields_final.push(disobj)

    }
    if (values.DropdownText) {
      let dropobj = {
        "name": "KIT_PRODUCT_NAME",
        "value": values.DropdownText.toString()
      }
      if (data?.select_kit_name?.id) {
        dropobj.id = data.select_kit_name.id
      }
      custom_fields_final.push(dropobj)
    }

    const deletedImages =
      (available_images || [])
        .filter(img => !(images || []).some(i => i.id === img.id))
        .map(img => img.id);


    let findprimary = null;
    const rawMultiKitData = form.getFieldValue("multi_kit_prods") || [];

    const multiKitData = innerProducts.multi_kit_prods.map((group, i) => {
      const { id, ...restGroup } = group;

      return ({
        ...restGroup,
        categoryMessage: rawMultiKitData[i]?.categoryMessage || "",
        categoryName: rawMultiKitData[i]?.categoryName || "",
        // categoriesName: group.categoriesName || [],
        products: (group.products || []).map(p => {
          const next = { ...p };

          // If a new imageUrl is provided and different from current image
          if (next.imageUrl) {
            const oldUrl = next.image ? String(next.image) : '';
            const newUrl = String(next.imageUrl);
            if (oldUrl && newUrl && oldUrl !== newUrl) {
              // send the old image to removal (only GCP urls)
              if (oldUrl.startsWith('https://storage.googleapis.com/')) {
                remove_from_GCP.push(oldUrl);
              }
              // Replace image with the new one
              next.image = newUrl;
            } else if (!oldUrl) {
              // no previous image, just set it
              next.image = newUrl;
            }
            delete next.imageUrl;
          }

          // If image is an object (from UploadButton), normalize to URL string
          if (next.image && typeof next.image === 'object' && next.image.thumbUrl) {
            next.image = next.image.thumbUrl;
          }

          return next;
        })
      });
    });

    // // Then in req_data:
    // const req_data = {
    //   // ...
    //   data: {
    //     // ...
    //     multi_kit_prods: multiKitData,
    //     // ...
    //   },
    //   remove_from_GCP,
    //   // ...
    // };


    let req_data = {
      "store": data.store,
      "store_id": data.store_id,
      "product_id": data.prod_id,
      "data": {
        "name": values.KitName,
        "sku": values.sapSku,
        "intro_txt": values.IntroText,
        "images": images && images.length > 0 ? images : [],
        "custom_fields": custom_fields_final,
        "categories": selectedValues,
        // "multi_kit_prods": form.getFieldValue("multi_kit_prods"),
        "multi_kit_prods": multiKitData,
        "price": values.price,
        "sale_price": "0"
      },
      custom_fields_removed,
      "images_removed": deletedImages,
      remove_from_GCP,
      "is_multi_kit_product": true,
    }

    setisloader(true)
    let responsedata = await common_api.update_product(req_data)
    if (responsedata) {
      await onProductCreate();
      triggerNotification(responsedata)
    }
    setisloader(false)
    onClose()
  }
  // ** Functions ( End )

  // ** Effects ( Start )
  useEffect(() => {
    const fetchData = async () => {
      if (globalData && globalData.all_cat_list && globalData.all_cat_list.length > 0) {
        let cattree = await globalData.all_cat_list.filter(item => item.store_id === kidata.store_id)
        if (cattree && cattree.length > 0) {
          setTreeData(cattree[0].treedata)
        }
      }


      form.setFieldsValue({
        msrpPrice: data.currency_symbol + '' + data.prod_msrp,
        salePrice: data.currency_symbol + '' + data.prod_sale_price,
        SAPmsrp: data.sapMsrp,
        SAPPrice: data.sapPrice,
        KitName: data.kitname,
        DropdownText: data.select_kit_name?.value || '',
        DiscountValue: data.discount?.value || '',
        store: data.store,
        LastUpdate: data.lastUpdated,
        sapSku: data.bcSku,
        SaleMsrp: data.msrp,
        status: data.active,
        IntroText: data.intro_txt,
        multi_kit_prods: data.multi_kit_prods,
        price: data.msrp,
        // salePrice: data.sale_price
      });

      const customMultiKitDataWithGroupIds = {
        ...data, // keep all other properties
        multi_kit_prods: data.multi_kit_prods.map(group => ({
          ...group,
          id: uuidv4(), // assign unique id per group
          products: group?.products?.map(product => ({
            ...product,
            unique_id: uuidv4() // assign unique id per product
          }))
        }))
      };


      console.log("customMultiKitDataWithGroupIds ===>", customMultiKitDataWithGroupIds)
      setInnerProducts(customMultiKitDataWithGroupIds)
      form.setFieldsValue({ multi_kit_prods: customMultiKitDataWithGroupIds?.multi_kit_prods })

    }
    if (kidata.categories.length > 0) {
      const categoriesStringArray = kidata.categories.map(String);

      setSelectedValues(categoriesStringArray)

    } else {
      setSelectedValues([])
    }
    if (kidata && visible) {
      fetchData();
      setData(kidata);
      setBundleTitle(kidata.kitname || "New Simple Product");

      if (kidata.images) {
        if (Array.isArray(kidata.images)) {
          const thumbnailImage = kidata.images.filter(img => img.description === "");
          if (thumbnailImage && thumbnailImage.length) {
            setThumbnailObj({ img_data: thumbnailImage });
          }
        }
      }
    }
  }, [kidata, visible, data, form]);

  return (
    <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={bundleTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div className="DrawerButtonBox">
            {data.active == true && kidata.bc_url !== "" && (
              <a href={kidata.bc_url ? kidata.bc_url : ""} target="_blank" title="View on Storefront" style={{ marginRight: 8 }} className="ViewPage" rel="noopener noreferrer">
                <ExportOutlined className="ViewPageIcon" style={{ fontSize: 16, color: 'rgba(0,0,0,0.88)' }} />
              </a>
            )}
            <Button
              className="ExpandDrawer"
              onClick={() => setIsExpanded(!isExpanded)}
              style={{ marginRight: 8 }}
            >
              {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
            </Button>
            {userData?.data?.access === "ALL" && (
              <Dropdown.Button
                type="primary"
                icon={<DownOutlined />}
                menu={{
                  items: ButtonItems,
                  onClick: handleMenuClick,
                }}
                trigger={['click']}
                onClick={handleSaveAndPublishClick}
                style={{ marginLeft: 8 }}
              >
                Save & Publish
              </Dropdown.Button>
            )}
          </div>
        </>
      }
    >
      <Form layout="vertical" form={form}>
        <StatusBadge
          status={form.getFieldValue("status")}
          lastEdited={data.lastUpdated}
        />
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlex" : ""}`}>
          <div className={`${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Multi Kit Name&nbsp;
                </span>
              }
              name="KitName"
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    const firstChar = value.charAt(0);
                    if (!value || value.trim() === "") {
                      return Promise.reject(new Error("Please enter Multi Kit Name"));
                    }
                    if (!firstChar.match(/[a-zA-Z0-9]/)) {
                      return Promise.reject(new Error("First character must be a letter or number"));
                    }

                    if (value.length > 255) {
                      return Promise.reject(new Error("Multi Kit Name cannot exceed 255 characters"));
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Enter New Multi Kit Product" onChange={handleBlur}/>
            </Form.Item>
          </div>
          <Flex className={`flexbox ${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Store&nbsp;
                </span>}
              name="store" className="disabledstore">
              <Input placeholder="Enter a Store" disabled />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  BC Sku&nbsp;
                </span>
              }
              name="sapSku"
              className="sap_sku_select"
              rules={[
                { required: true, message: "Please Select BC Sku" },
              ]}
            >
              <Input
                style={{ width: "100%" }}
                placeholder="Enter BC Sku"

              />
            </Form.Item>

          </Flex>

          <div className={`${isExpanded ? "w-50" : ""}`}>
            <Form.Item
              label={
                <span>
                  Default Price&nbsp;
                </span>
              }
              name="price"
              rules={
                [
                  {
                    required: true,
                    validator: (_, value) => {
                      if (value === undefined || value === "") {
                        return Promise.reject("Please enter Default Price");
                      }
                      const num = Number(value);
                      if (isNaN(num)) {
                        return Promise.reject("Price must be a number");
                      }
                      if (num <= 0) {
                        return Promise.reject("Price must be greater than 0");
                      }
                      if (num > 10000000) {
                        return Promise.reject("Price must be less than or equal to 10000000");
                      }
                      return Promise.resolve();
                    }
                  }
                ]
              }
            >
              <Input placeholder="Enter Price" />
            </Form.Item>
          </div>

          <div className={`${isExpanded ? "w-33" : ""}`}>
            <Form.Item
              label={
                <span>
                  Product Categories&nbsp;
                </span>
              }
              rules={[{ required: true, message: "Please select at least one category" }]}
            >

              <TreeSelect
                className="CategoryTree"
                multiple
                treeData={treeData}
                value={selectedValues}
                onChange={onChange}
                placeholder="Select categories"
              />
            </Form.Item>
          </div>
        </div>
        <Form.Item
          label={
            <span>
              PDP Image&nbsp;
            </span>
          }
          name="Dropdown Thumbnail"
        >
          <UploadButton
            setSavedimgaes={setSavedimgaes}
            product_obj={thumbnailObj}
            MAX_UPLOADS="10"
            delete="true"
            replace="true"
            thumbnail="false"
            hover=""
          />
        </Form.Item>


        <div className={`${isExpanded ? "w-50" : ""}`}>
          <Form.Item
            label={
              <span>
                Intro Text&nbsp;
              </span>
            }
            name="IntroText"
            rules={[{ required: true, whitespace: true, message: "Please enter Intro Text" }]}
          >
            <Input placeholder="Enter Intro Text" />
          </Form.Item>
        </div>
        {/* Dropdown button */}

        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlex" : ""}`}>



          <div className={`${isExpanded ? "w-50" : ""}`}>
            <Form.Item
              label="Discount Value"
              name="DiscountValue"
              rules={[
                { required: true, whitespace: true, message: "Please enter Discount Value" },
                {
                  validator: (_, value) => {
                    if (value === undefined || value === "") {
                      return Promise.resolve(); // handled by 'required'
                    }
                    const numericValue = parseFloat(value);
                    if (numericValue < 0 || numericValue > 100) {
                      return Promise.reject("Value must be between 0 and 100");
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input
                placeholder="Enter Discount Value"
                style={{ width: "100%" }}
                value={data.discount_value}
                onChange={handleInputChange("DiscountValue")}
                addonAfter="%"
              />
            </Form.Item>

          </div>
        </div>

        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes" : ""}`}>
          {visible && <CommonAttributeList setRemovedValues={setRemovedValues} setSavedattributes={setSavedattributes} customfielddata={data} setHasAttributeError={setHasAttributeError} />}
        </div>
        <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes VariantProductList" : ""}`} style={{ marginTop: "16px" }}>
          {visible && innerProducts && <MultiKitProductGroupList store_id={data?.store_id} kitProduct={data} form={form} setInnerProducts={setInnerProducts} innerProducts={innerProducts} />}
        </div>



      </Form>
    </Drawer>
  );
};

export default MultiKitDrawer;